// extracted by mini-css-extract-plugin
export default {"main":"dashboard_main__LoSkx","container":"dashboard_container__lmBTr","cards":"dashboard_cards__Y2lHP"};